import { logEvent } from "../../utils/analytics";
import { useServicesAtTempleFunctions } from "./customHook";
import "./servicesattemple.css";
import { Link } from "react-router-dom";
import templeJson from '../../config/temple.json';
import { Box, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ServicesAtTemple() {
  const { serviceCategories } = useServicesAtTempleFunctions();
  const navigate = useNavigate();
  const isStyleOne = templeJson["Services"]?.style === 1;
  const servicestyle = {
    head: isStyleOne ? "container-fluid page-header py-4 service-head-dt" : "container-fluid page-header py-4 service-head-svt"
  }
  const handleCategoryClick = (item) => {
    logEvent(
      "Services Category Interaction",
      "Service Category Clicked",
      item.title
    );
  };
  return (
    <>
      <Box className={servicestyle?.head}>
        <h1 className="text-center service-head display-6">
          Services at Temple
        </h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Services at Temple</li>
        </ol>
      </Box>
      <Box className="container-fluid py-5">
        <Grid className="container pt-4">
          <Grid className="text-center">
            <h6 className="section-title text-center text-primary text-uppercase title-tl">
              {templeJson["templeName"]}
            </h6>
            <h1 className="mb-3">
              <span className="text-secundary">Service at Temple</span>
            </h1>
          </Grid>
          <Grid className="container py-4">
            <Grid className="row g-4">
              {serviceCategories &&
                serviceCategories.map((item) => (
                  <Grid className="col-lg-3 col-md-6">
                    <Button
                      className="service-item d-block rounded text-center h-100 p-3"
                      onClick={() =>{ 
                        navigate(`/services/${item.slug}`);
                        handleCategoryClick(item);
                      }}
                    >
                      <img
                        className="img-fluid rounded mb-3"
                        src={item.image}
                        alt={item.title}
                      />
                      <h4 className="mb-0">{item.title}</h4>
                      {/* <a href="#!">
                        <i className="fa fa-download" onClick={(e) => downloadImg(item.image, e)} />
                      </a> */}
                    </Button>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
export default ServicesAtTemple;
